export default "__VITE_ASSET__d23bd39a__"